import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { Input, Select, Button, DatePicker, TimePicker } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import Axios from "../../../services/AxiosInterceptor";

const { TextArea } = Input;

const EditService = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const STORAGE_URL = "https://yogamatic.in/api/";

  // State variables
  const [preview, setPreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    classMode: '',
    sessionType: '',
    seatAvailability: '',
    benefits: ['', '', '', '', ''],
    description: '',
    amount: '',
    discount: '',
  });
  const [locationSpecificData, setLocationSpecificData] = useState({});
  const [locationandRec, setLocationandRec] = useState([]);
  const [locationIndex, setLocationIndex] = useState(0);
  const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  // Load locations and resources
  const getLocationandresource = async () => {
    try {
      const response = await Axios.get('/api/location-list');
      const result = response.data;
      if (result) {
        setLocationandRec(result);
      }
    } catch (error) {
      console.error('Error loading location & resource:', error);
    }
  };

  // Fetch existing service data
  const getServiceData = useCallback(async () => {
    if (!id) return;
    try {
      const response = await Axios.post('/api/yoga_single_service', { id: { id } });
      const result = response.data;
      if (result && result.success && result.data) {
        const service = result.data;
        
        setFormData({
          title: service.title || '',
          classMode: service.classMode || '',
          sessionType: service.sessionType || '',
          seatAvailability: service.seatAvailability || '',
          benefits: service.benefits || ['', '', '', '', ''],
          description: service.description || '',
          amount: service.pricing?.amount || '',
          discount: service.pricing?.discount || '',
        });

        if (service.image) {
          setPreview(service.image);
        }

        // Map locations to locationSpecificData
        const locData = {};
        const savedSchedule = service.schedule || {};

        if (service.locations && Array.isArray(service.locations)) {
          service.locations.forEach(loc => {
            const locName = loc.name;
            const scheduleForLoc = savedSchedule[locName] || {};

            locData[locName] = {
              resources: loc.resources || [],
              sessions: loc.sessions || [],
              // Use saved schedule data if available, otherwise try to infer or default
              startDate: scheduleForLoc.startDate || loc.sessions[0]?.date || '',
              endDate: scheduleForLoc.endDate || '',
              sessionDuration: scheduleForLoc.sessionDuration || '',
              startTime: scheduleForLoc.startTime || '',
              endTime: scheduleForLoc.endTime || '',
              offDays: scheduleForLoc.offDays || [],
              bufferTime: scheduleForLoc.bufferTime || '',
            };
          });
        }
        setLocationSpecificData(locData);
      }
    } catch (error) {
      console.error('Error fetching service data:', error);
    }
  }, [id]);

  useEffect(() => {
    getLocationandresource();
    if (id) {
      getServiceData();
    }
  }, [id, getServiceData]);

  // Handlers for form fields
  const handleCommonField = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const handleLocationField = (key, value) => {
    const currentLocation = locationandRec[locationIndex]?.location;
    setLocationSpecificData(prev => ({
      ...prev,
      [currentLocation]: {
        ...prev[currentLocation],
        [key]: value,
      },
    }));
  };

  const handleImageChange = e => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleBenefitsChange = (idx, val) => {
    const updated = [...formData.benefits];
    updated[idx] = val;
    setFormData(prev => ({ ...prev, benefits: updated }));
  };

  const handleSubmitSessions = async () => {
    const currentLocation = locationandRec[locationIndex]?.location;
    const sessionData = locationSpecificData[currentLocation] || {};
    try {
      const response = await Axios.post(
        '/api/session-creation',
        {
          startDate: sessionData.startDate,
          endDate: sessionData.endDate,
          sessionDuration: sessionData.sessionDuration,
          startTime: sessionData.startTime,
          endTime: sessionData.endTime,
          offDays: sessionData.offDays,
          bufferTime: sessionData.bufferTime,
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      const result = response.data;
      if (result?.success) {
        setLocationSpecificData(prev => ({
          ...prev,
          [currentLocation]: {
            ...prev[currentLocation],
            sessions: result.sessionData.sessions,
          },
        }));
        alert('Sessions generated successfully!');
      }
    } catch (err) {
      console.error('❌ Error:', err);
      alert('Error generating sessions');
    }
  };

  const handlelocaationIndex = idx => setLocationIndex(idx);

  const handlecheck = resource => {
    const currentLocation = locationandRec[locationIndex].location;
    setLocationSpecificData(prev => {
      const locData = prev[currentLocation] || {};
      const resources = locData.resources || [];
      const updated = resources.includes(resource)
        ? resources.filter(r => r !== resource)
        : [...resources, resource];
      return {
        ...prev,
        [currentLocation]: { ...locData, resources: updated },
      };
    });
  };

  const handleSubmit1 = async () => {
    const locations = Object.keys(locationSpecificData).map(loc => ({
      name: loc,
      resources: locationSpecificData[loc].resources || [],
      sessions: locationSpecificData[loc].sessions || [],
    }));

    // Prepare schedule data to save
    const scheduleData = {};
    Object.keys(locationSpecificData).forEach(loc => {
      scheduleData[loc] = {
        startDate: locationSpecificData[loc].startDate,
        endDate: locationSpecificData[loc].endDate,
        startTime: locationSpecificData[loc].startTime,
        endTime: locationSpecificData[loc].endTime,
        sessionDuration: locationSpecificData[loc].sessionDuration,
        bufferTime: locationSpecificData[loc].bufferTime,
        offDays: locationSpecificData[loc].offDays,
      };
    });

    const submitData = {
      title: formData.title,
      classMode: formData.classMode,
      sessionType: formData.sessionType,
      seatAvailability: parseInt(formData.seatAvailability),
      benefits: formData.benefits.filter(b => b.trim() !== ''),
      description: formData.description,
      pricing: {
        currency: 'Rupees',
        amount: parseFloat(formData.amount || 0),
        discount: parseFloat(formData.discount || 0),
      },
      locations,
      schedule: scheduleData,
    };
    const fd = new FormData();
    
    if (id) {
        fd.append('serviceId', id);
    }

    fd.append('services[0][title]', submitData.title);
    fd.append('services[0][classMode]', submitData.classMode);
    fd.append('services[0][sessionType]', submitData.sessionType);
    fd.append('services[0][seatAvailability]', submitData.seatAvailability);
    submitData.benefits.forEach((b, i) => fd.append(`services[0][benefits][${i}]`, b));
    fd.append('services[0][description]', submitData.description);
    if (imageFile) fd.append('image', imageFile);
    
    // Append schedule as a JSON string
    fd.append('services[0][schedule]', JSON.stringify(submitData.schedule));

    submitData.locations.forEach((loc, i) => {
      fd.append(`services[0][locations][${i}][name]`, loc.name);
      loc.resources.forEach((r, ri) => fd.append(`services[0][locations][${i}][resources][${ri}]`, r));
      loc.sessions.forEach((s, si) => {
        fd.append(`services[0][locations][${i}][sessions][${si}][date]`, s.date);
        s.timeSlots.forEach((t, ti) => fd.append(`services[0][locations][${i}][sessions][${si}][timeSlots][${ti}][time]`, t));
      });
    });
    fd.append('services[0][pricing]', JSON.stringify(submitData.pricing));
    
    try {
      const endpoint = id ? '/api/yoga_update_service' : 'http://13.201.108.246:5000/api/yoga_add_services';
      const response = await Axios.post(endpoint, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const result = response.data;
      if (result?.success) {
        alert(id ? 'Service updated successfully!' : 'Service added successfully!');
        if (!id) {
            setFormData({
            title: '',
            classMode: '',
            sessionType: '',
            seatAvailability: '',
            benefits: ['', '', '', '', ''],
            description: '',
            amount: '',
            discount: '',
            });
            setLocationSpecificData({});
            setPreview(null);
            setImageFile(null);
            setLocationIndex(0);
        } else {
             navigate('/servicelist'); 
        }
      } else {
        console.error('Server response:', result);
        alert('Failed to save service: ' + (result.message || 'Unknown error'));
      }
    } catch (e) {
      console.error('Error:', e);
      alert('An error occurred while submitting the form.');
    }
  };

  const currentLocation = locationandRec[locationIndex]?.location;
  const currentLocationData = locationSpecificData[currentLocation] || {};

  return (
    <div className="container p-6 mx-auto">
      <h3 className="mb-4 text-2xl font-semibold">{id ? 'Edit Service' : 'Add New Service'}</h3>
      <div className="flex flex-col items-center p-4 mb-6 border border-orange-400 rounded-lg md:flex-row">
        <div className="w-full mb-4 md:w-1/2 md:mb-0">
          <Input type="file" onChange={handleImageChange} className="w-full" accept="image/*" />
        </div>
        <div className="flex flex-col items-center w-full md:w-1/2">
          <p>Preview:</p>
          {preview && <img src={`${STORAGE_URL}upload/${preview}`} alt="Preview" className="h-auto max-w-full mt-2 border rounded-lg" />}
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 p-6 border border-orange-400 rounded-lg md:grid-cols-3">
        <div>
          <label className="block font-medium">Title</label>
          <Input placeholder="Service Title" value={formData.title} onChange={e => handleCommonField('title', e.target.value)} />
        </div>
        <div>
          <label className="block font-medium">Choose Class Mode</label>
          <Select
            value={formData.classMode || 'Choose Class Mode'}
            onChange={v => handleCommonField('classMode', v)}
            className="w-full"
          >
            <Select.Option value="Online">Online</Select.Option>
            <Select.Option value="Offline">Offline</Select.Option>
          </Select>
        </div>
        <div>
          <label className="block font-medium">Select Session Type</label>
          <Select
            value={formData.sessionType || 'Select Session Type'}
            onChange={v => handleCommonField('sessionType', v)}
            className="w-full"
          >
            <Select.Option value="Group Session">Group Session</Select.Option>
            <Select.Option value="Personal Session">Personal Session</Select.Option>
          </Select>
        </div>
        <div>
          <label className="block font-medium">Enter Seat Availability</label>
          <Input type="number" placeholder="Seats Available" value={formData.seatAvailability} onChange={e => handleCommonField('seatAvailability', e.target.value)} className="w-full" />
        </div>
      </div>
      <div className="p-6 mt-2 border border-orange-400 rounded-lg">
        <label className="block font-medium">Benefits</label>
        <br />
        <div style={{ display: 'flex' }}>
          {formData.benefits.map((b, i) => (
            <Input key={i} placeholder={`Benefit ${i + 1}`} value={b} onChange={e => handleBenefitsChange(i, e.target.value)} />
          ))}
        </div>
        <div>
          <label className="block font-medium">Service Description</label>
          <TextArea value={formData.description} onChange={e => handleCommonField('description', e.target.value)} />
        </div>
      </div>
      <div className="gap-2 p-6 mt-2 border border-orange-400 rounded-lg">
        <label className="block font-medium">Location &amp; Resource</label>
        {locationandRec.length ? (
          locationandRec.map((item, idx) => (
            <Button key={idx} style={{ background: locationIndex === idx ? 'orange' : '' }} onClick={() => handlelocaationIndex(idx)}>
              {item.location}
            </Button>
          ))
        ) : (
          <p>Loading...</p>
        )}
        <div>
          {locationandRec.length && locationandRec[locationIndex].resource ? (
            locationandRec[locationIndex].resource.map((res, i) => (
              <label key={i}>
                <input type="checkbox" checked={(currentLocationData.resources || []).includes(res)} onChange={() => handlecheck(res)} />
                {res}
              </label>
            ))
          ) : (
            <p className="text-gray-500">No resources available</p>
          )}
        </div>
      </div>
      <label className="block font-medium">Sessions for {currentLocation}</label>
      <div className="gap-2 p-6 mt-2 border border-orange-400 rounded-lg d-flex">
        <div>
          <label className="block font-medium">Start Date</label>
          <DatePicker
            className="w-full"
            placeholder="Start Date"
            value={currentLocationData.startDate ? moment(currentLocationData.startDate) : null}
            onChange={(d, ds) => handleLocationField('startDate', ds)}
          />
        </div>
        <div>
          <label className="block font-medium">End Date</label>
          <DatePicker
            className="w-full"
            placeholder="End Date"
            value={currentLocationData.endDate ? moment(currentLocationData.endDate) : null}
            onChange={(d, ds) => handleLocationField('endDate', ds)}
          />
        </div>
        <div>
          <label className="block font-medium">Session Duration</label>
          <Input className="w-full" placeholder="Duration (in hours)" value={currentLocationData.sessionDuration} onChange={e => handleLocationField('sessionDuration', e.target.value)} />
        </div>
        <div>
          <label className="block font-medium">Buffer Time</label>
          <Input className="w-full" placeholder="Buffer Time (in minutes)" value={currentLocationData.bufferTime} onChange={e => handleLocationField('bufferTime', e.target.value)} />
        </div>
        <div>
          <label className="block font-medium">Start Time</label>
          <TimePicker
            className="w-full"
            placeholder="Start Time"
            format="HH:mm"
            value={currentLocationData.startTime ? moment(currentLocationData.startTime, 'HH:mm') : null}
            onChange={(t, ts) => handleLocationField('startTime', ts)}
          />
        </div>
        <div>
          <label className="block font-medium">End Time</label>
          <TimePicker
            className="w-full"
            placeholder="End Time"
            format="HH:mm"
            value={currentLocationData.endTime ? moment(currentLocationData.endTime, 'HH:mm') : null}
            onChange={(t, ts) => handleLocationField('endTime', ts)}
          />
        </div>
        <div style={{ width: '200px' }}>
          <label className="block font-medium">Off Days</label>
          <Select
            mode="multiple"
            placeholder="Select Off Days"
            value={currentLocationData.offDays || []}
            onChange={v => handleLocationField('offDays', v)}
            className="w-full"
          >
            {weekDays.map(day => (
              <Select.Option key={day} value={day}>
                {day}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Button style={{ marginTop: '20px', background: 'orange' }} onClick={handleSubmitSessions}>Save Sessions</Button>
      </div>
      <div className="p-6 mt-2 border border-orange-400 rounded-lg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-6"><label>Session Dates</label></div>
                <div className="col-6"><label>Times</label></div>
              </div>
            </div>
            <div className="col-12">
              <div className="row">
                <div className="col-12">
                  <hr />
                  {currentLocationData.sessions?.map((session, si) =>
                    session.timeSlots.map((ts, ti) => (
                      <div className="row" key={`${si}-${ti}`}>
                        <div className="col-6">{ti === 0 && <button>{session?.date}</button>}</div>
                        <div className="col-6"><button>{typeof ts === 'object' ? ts.time : ts}</button></div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-wrap col-span-1 gap-4 md:col-span-3">
          <div className="w-full md:w-1/4">
            <label className="block font-medium">Currency</label>
            <Input placeholder="Currency" value="Rupees" disabled />
          </div>
          <div className="w-full md:w-1/4">
            <label className="block font-medium">Amount</label>
            <Input placeholder="Amount" value={formData.amount} onChange={e => handleCommonField('amount', e.target.value)} />
          </div>
          <div className="w-full md:w-1/4">
            <label className="block font-medium">Discount</label>
            <Input placeholder="Discount" value={formData.discount} onChange={e => handleCommonField('discount', e.target.value)} />
          </div>
          <div className="w-full md:w-1/4">
            <Button className="block font-medium" onClick={handleSubmit1}>{id ? 'Update Service' : 'Save Service'}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditService;